import { format as fnsFormat } from 'date-fns'

export const getQueryDate = (date?: Date): string => {
  return fnsFormat(date || new Date(), 'yyyy-MM-dd')
}
